













import { Component, Prop, Vue } from 'vue-property-decorator';
import TechCard from './TechCard.vue';
import { Technology, Card } from '../model/technology';

@Component({
  components: {
    TechCard,
  },
})
export default class CardsRow extends Vue {
  @Prop() private name!: string;

  @Prop() private cards!: Array<Card>;

  @Prop() private highlightedCards!: Array<Card>;

  highlight(card: Card): boolean {
    return this.highlightedCards.includes(card);
  }
}
